import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { statusLabel } from './surveyMetrics';

type Props = {
  show: boolean; name: string; from?: string; to?: string; childCount: number;
  // A parent change: the markets it also changes, listed by name.
  markets?: string[];
  onCancel: () => void; onConfirm: () => void; setupOpen?: boolean;
};

export const StatusConfirm: React.FC<Props> = ({ show, name, from, to, childCount, markets, onCancel, onConfirm, setupOpen }) => (
  <Modal show={show} onHide={onCancel} centered>
    <Modal.Header closeButton><Modal.Title>Change survey status?</Modal.Title></Modal.Header>
    <Modal.Body>
      <p className="mb-1">Change <strong>{name}</strong> from {statusLabel(from)} to <strong>{statusLabel(to)}</strong>?</p>
      {markets && markets.length > 0 ? (
        <>
          <p className="mb-1 text-muted">This changes the project and all {markets.length} market{markets.length === 1 ? '' : 's'}:</p>
          <ul className="mb-1 text-muted dx-status-markets">
            {markets.map((m) => <li key={m}>{m}</li>)}
          </ul>
        </>
      ) : (childCount > 0 && <p className="mb-1 text-muted">This also updates all {childCount} child market(s).</p>)}
      {to === 'Open' && <p className={`${setupOpen ? 'mb-1' : 'mb-0'} text-muted`}>Live surveys start receiving real respondents.</p>}
      {setupOpen && <p className="mb-0 text-muted">Unsaved changes in Setup will be lost.</p>}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="light" onClick={onCancel}>Cancel</Button>
      <Button variant="primary" onClick={onConfirm}>Yes, change</Button>
    </Modal.Footer>
  </Modal>
);
